/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Models_Category_LlmInputs */

const en_directory_models_category_llm = /** @type {(inputs: Directory_Models_Category_LlmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language models`)
};

const zh_directory_models_category_llm = /** @type {(inputs: Directory_Models_Category_LlmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大语言模型`)
};

/**
* | output |
* | --- |
* | "Language models" |
*
* @param {Directory_Models_Category_LlmInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_category_llm = /** @type {((inputs?: Directory_Models_Category_LlmInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_Category_LlmInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_category_llm(inputs)
	return zh_directory_models_category_llm(inputs)
});
export { directory_models_category_llm as "directory.models.category.llm" }